import routes from './routes/affiliate.routes';
import ModuleBase from '../../classes/ModuleBase';

export default new ModuleBase({
    name: 'Affiliate',
    routes: {
        requiresAuth: routes.requiresAuth
    }
});